import { useNavigate } from "react-router";
import { DropdownItem } from "../components/Dropdown/SelectDrop/selectDropdown";

export const useCompanyDetailsControllers = () => {
  const handleAction = (type: string) => {
    console.log(`Download as ${type}`);
  };
  const navigate = useNavigate();
  const servicesData = [
    {
      label: "Local dispatch",
      onClick: () => console.log("Local dispatch clicked"),
    },
    {
      label: "Interstate delivery",
      onClick: () => console.log("Interstate clicked"),
    },
    {
      label: "Local relocation",
      onClick: () => console.log("Relocation clicked"),
    },
  ];

  const actionOption: DropdownItem[] = [
    { label: "Deactivate", onClick: () => handleAction("Deactivate") },
    { label: "Suspend", onClick: () => handleAction("Suspend") },
  ];
  return {
    // state
    navigate,
    // data
    actionOption,
    servicesData,
  };
};
